import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { ComingSoon } from "@/components/coming-soon";
import { orpc } from "@/orpc/client";

export const Route = createFileRoute("/_app/episodes/$episodeId/settings")({
	component: Page,
	params: z.object({
		episodeId: z.coerce.number(),
	}),
	async loader({ context, params, preload }) {
		if (!preload) {
			return;
		}

		context.queryClient.prefetchQuery(
			orpc.episodes.show.queryOptions({
				input: {
					episodeId: params.episodeId,
				},
			}),
		);
	},
});

function Page() {
	return <ComingSoon />;
	// const params = Route.useParams();

	// const { data: channel } = useSuspenseQuery(
	// 	orpc.episodes.show.queryOptions({
	// 		input: {
	// 			episodeId: params.episodeId,
	// 		},
	// 	}),
	// );

	// return (
	// 	<div className="px-4 lg:px-6 grid grid-cols-12 gap-6">
	// 		<FormCard className="col-span-12">
	// 			<FormCardHeader>
	// 				<FormCardTitle>Channel Meta</FormCardTitle>
	// 			</FormCardHeader>
	// 			<FormCardContent>
	// 				<FieldGroup>
	// 					<Field className="lg:col-span-6">
	// 						<FieldLabel>ID</FieldLabel>
	// 						<CopyInput value={channel.ID.toString()} readOnly />
	// 					</Field>
	// 					<Field className="lg:col-span-6">
	// 						<FieldLabel>UID</FieldLabel>
	// 						<CopyInput value={channel.UID.toString()} readOnly />
	// 					</Field>
	// 					<Field className="lg:col-span-6">
	// 						<FieldLabel>Status</FieldLabel>
	// 						<CopyInput
	// 							value={getChannelStatus(channel.StatusID).label}
	// 							readOnly
	// 						/>
	// 					</Field>
	// 					<Field className="lg:col-span-6">
	// 						<FieldLabel>URL slug</FieldLabel>
	// 						<CopyInput value={channel.UrlTitle} readOnly>
	// 							<InputGroupAddon align="inline-end">
	// 								<TooltipProvider>
	// 									<Tooltip>
	// 										<TooltipTrigger
	// 											render={
	// 												<Button
	// 													variant="link"
	// 													size="icon-sm"
	// 													nativeButton={false}
	// 													render={
	// 														<a
	// 															href={`https://s3.console.aws.amazon.com/s3/buckets/${import.meta.env.VITE_AWS_S3_BUCKET}?region=us-east-1&prefix=${channel.UrlTitle}&delimiter=/`}
	// 															target="_blank"
	// 														/>
	// 													}
	// 												>
	// 													<IconBrandAws />
	// 												</Button>
	// 											}
	// 										/>
	// 										<TooltipContent>Open in S3 Console</TooltipContent>
	// 									</Tooltip>
	// 								</TooltipProvider>
	// 							</InputGroupAddon>
	// 						</CopyInput>
	// 						<FieldDescription>
	// 							This is the URL-friendly version of the channel title, used in
	// 							S3 buckets to store files but also for constructing the
	// 							channel's public URL.
	// 						</FieldDescription>
	// 					</Field>
	// 					<Field className="lg:col-span-6 col-start-1">
	// 						<FieldLabel>Updated Date</FieldLabel>
	// 						<CopyInput value={channel.UpdatedDate?.toISOString()} readOnly />
	// 					</Field>
	// 					<Field className="lg:col-span-6">
	// 						<FieldLabel>Created Date</FieldLabel>
	// 						<CopyInput value={channel.CreatedDate?.toISOString()} readOnly />
	// 					</Field>
	// 				</FieldGroup>
	// 			</FormCardContent>
	// 		</FormCard>
	// 		<FormCard className="col-span-12">
	// 			<FormCardHeader>
	// 				<FormCardTitle>Delete Channel</FormCardTitle>
	// 			</FormCardHeader>
	// 			<FormCardAlert variant="destructive">
	// 				<AlertTitle>Are you sure you want to delete this channel?</AlertTitle>
	// 				<AlertDescription>
	// 					This action cannot be undone. This will permanently delete the
	// 					channel and all of its data.
	// 				</AlertDescription>
	// 				<AlertAction>
	// 					<DeleteChannelDialog channelId={channel.ID}>
	// 						<Button variant="destructive">Delete Channel</Button>
	// 					</DeleteChannelDialog>
	// 				</AlertAction>
	// 			</FormCardAlert>
	// 		</FormCard>
	// 	</div>
	// );
}
